export default __webpack_public_path__ + "static/media/coin-fountain.9af717f3.gif";